import { Link } from "react-router";

type UnstyledLinkProps = {
  children: React.ReactNode;
  to: string;
  openInNewTab?: boolean;
  className?: string;
};

export const UnstyledLink = (props: UnstyledLinkProps) => {
  return (
    <Link
      to={props.to}
      target={props.openInNewTab ? "_blank" : undefined}
      style={{
        textDecoration: "none",
        color: "inherit",
      }}
      className={props.className}
    >
      {props.children}
    </Link>
  );
};
